var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher-settings" } },
    [
      _c("app-launcher-versions", {
        attrs: {
          "s-active": _vm.sActive,
          "s-initial": _vm.sInitial,
          versions: _vm.versions,
          "migrations-by-range": _vm.migrationsByRange,
          "is-disabled": _vm.isDisabled,
        },
        on: {
          "settings-change": function ($event) {
            return _vm.$emit("settings-change", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("app-launcher-options", {
        attrs: { settings: _vm.sActive, "is-disabled": _vm.isDisabled },
        on: {
          "settings-change": function ($event) {
            return _vm.$emit("settings-change", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }